<app-menu>
    <div class="form-container">
        <div class="step-content">
            <h2 class="form-title">Warehouse Creator</h2>
            <div [formGroup]="warehouse_form">
                <div class="section-cards">
                    <mat-card class="card">
                        <mat-card-header>
                            <mat-card-title>Warehouse Profile</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <mat-form-field class="input-container">
                                <mat-label>Warehouse Name</mat-label>
                                <input matInput formControlName="inventory_warehouse_name"
                                    placeholder="Start typing warehouse name...">
                            </mat-form-field>
                        </mat-card-content>
                    </mat-card>
                    <mat-card class="card">
                        <mat-card-header>
                            <mat-card-title>Contact Details</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <mat-form-field class="input-container">
                                <mat-label>Contact Organization</mat-label>
                                <input matInput [matAutocomplete]="autoComplete" formControlName="contact_organization"
                                    placeholder="Start typing organization name...">
                                <mat-autocomplete #autoComplete="matAutocomplete">
                                    <mat-option *ngFor="let item of filteredContactList | async" [value]="item">
                                        <span>{{ item }}</span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </mat-card-content>
                    </mat-card>
                    <mat-card class="card">
                        <mat-card-header>
                            <mat-card-title>Warehouse Layout Overview</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="grid-container">
                                <mat-form-field class="input-container">
                                    <mat-label>Total No. of Rows</mat-label>
                                    <input matInput formControlName="no_rows">
                                </mat-form-field>
                                <mat-form-field class="input-container">
                                    <mat-label>No. of Sections per Row</mat-label>
                                    <input matInput formControlName="no_sections">
                                </mat-form-field>
                                <mat-form-field class="input-container">
                                    <mat-label>No. of Levels per Section</mat-label>
                                    <input matInput formControlName="no_levels">
                                </mat-form-field>
                                <mat-form-field class="input-container">
                                    <mat-label>No. of Spots per (Section+Level)</mat-label>
                                    <input matInput formControlName="no_spots">
                                </mat-form-field>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    <mat-card class="card">
                        <mat-card-header>
                            <mat-card-title>Warehouse Configuration</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <mat-form-field appearance="fill">
                                <mat-label>Select Row Naming Scheme</mat-label>
                                <mat-select [(value)]="rowNamingOption" formControlName="rowNamingOption">
                                    <mat-option *ngFor="let option of labelOptions" [value]="option">
                                        {{ option === 'Numbers' ? 'Numbers (1, 2, 3...)' : option === 'Letters' ?
                                        'Letters
                                        (A,
                                        B,
                                        C...)'
                                        : option }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="fill">
                                <mat-label>Select Section Naming Scheme</mat-label>
                                <mat-select [(value)]="sectionNamingOption" formControlName="sectionNamingOption">
                                    <mat-option *ngFor="let option of labelOptions" [value]="option">
                                        {{ option === 'Numbers' ? 'Numbers (1, 2, 3...)' : option === 'Letters' ?
                                        'Letters
                                        (A,
                                        B,
                                        C...)'
                                        : option }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </mat-card-content>
                    </mat-card>
                </div>
                <div class="submit-wrapper">
                    <button mat-raised-button color="primary" type="submit" (click)="submitForm()" [disabled]="warehouse_form.invalid">Submit</button>
                </div>
            </div>
        </div>
    </div>
</app-menu>